import { all } from "redux-saga/effects";
import { heSoLopTuNguyenSaga } from "./heSoLopTuNguyenSaga";

export default function* thietLapSagaWrapper() {
  yield all([heSoLopTuNguyenSaga()]);
}
